export enum FormField {
  NAME = "name",
  CUSTOM_NAME = "customName",
}
